const Regs = {
  phone: {
    required: true,
    validate: /^1[3456789]\d{9}$/,
    required_text: '手机号不能为空',
    validate_text: '手机号输入有误'
  },
  safeCode: {
    required: true,
    validate: /^\d{6}$/,
    required_text: '验证码不能为空',
    validate_text: '验证码输入有误'
  },
  username: {
    required: true,
    validate: /^\w{1,16}$/,
    required_text: '用户名不能为空',
    validate_text: '用户名输入有误'
  },
  password: {
    required: true,
    validate: /^\w{1,16}$/,
    required_text: '密码不能为空',
    validate_text: '密码输入有误'
  },
  code: {
    required: true,
    validate: /^\w{4}$/,
    required_text: '验证码不能为空',
    validate_text: '验证码输入有误'
  }
};

function validate(type, content) {
  if (Regs[type].required && content.length < 1) return Regs[type].required_text;
  if (!Regs[type].validate.test(content)) return Regs[type].validate_text;
  return null;
};

validate.group = function () {
  for (let i = 0; i < arguments.length; i++) {
    if (arguments[i]) return arguments[i];
  }
};

export default validate;



// WEBPACK FOOTER //
// ./src/utils/validate.js